import EnvoiMessage from './EnvoiMessage';
import EnvoiRappelLogin from './EnvoiRappelLogin';
import EnvoiRappelInstance from './EnvoiRappelInstance';

export default {
  install(Vue) {
    Vue.component('envoi-message', EnvoiMessage);
    Vue.component('envoi-rappel-login', EnvoiRappelLogin);
    Vue.component('envoi-rappel-instance', EnvoiRappelInstance);
  },
};
